import React from 'react';
import './VerbsList.css';
import { grammarData } from '../../data/grammarData';

const VerbsList = () => {
  return (
    <div className="verb-list">
      {grammarData.irregularVerbs.map((verb, index) => (
        <div key={index} className="verb-item">
          <div className="verb-header">
            <span className="verb-emoji">{verb.emoji}</span>
            <div className="verb-forms">
              <span className="infinitive">{verb.infinitive}</span>
              <span className="separator">-</span>
              <span className="past">{verb.past}</span>
              <span className="separator">-</span>
              <span className="past-participle">{verb.pastParticiple}</span>
            </div>
            <div className="verb-meaning">{verb.translation}</div>
          </div>
          {verb.examples && (
            <div className="verb-examples">
              {verb.examples.map((example, exIndex) => (
                <div key={exIndex} className="example-item">
                  <div className="example-en">{example.en}</div>
                  <div className="example-es">{example.es}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VerbsList;